export var Roles = {
    admin: 'admin',
    reader: 'reader'
};
var type = {
    reader: 'reader',
    admin: 'admin',
};
var list = {
    reader: { id: type.reader, title: 'Čtenář' },
    admin: { id: type.admin, title: 'Správce' },
};
export var userRoles = { type: type, list: list };
